/* buy-es: state and behaviour for the one-to-one buying section.
   One selected model drives the price, the gallery, the add-ons and the bar. */
(function () {
  function init(root) {
    var moneyFmt = root.getAttribute('data-money') || '{{amount}} NIS';
    /* 27.9 (personas): follow the store's money format for the visitor's currency, like Liquid does ("€1.139,95", not "€1,139.95") */
    function money(cents) {
      var m = moneyFmt.match(/\{\{\s*(\w+)\s*\}\}/), kind = m ? m[1] : 'amount';
      function f(dec, th, ds) { var p = (cents / 100).toFixed(dec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? ds + p[1] : ''); }
      var v = kind === 'amount_no_decimals' ? f(0, ',', '.') : kind === 'amount_with_comma_separator' ? f(2, '.', ',') : kind === 'amount_no_decimals_with_comma_separator' ? f(0, '.', ',') : kind === 'amount_with_apostrophe_separator' ? f(2, "'", '.') : kind === 'amount_with_space_separator' ? f(2, ' ', ',') : f(2, ',', '.');
      return moneyFmt.replace(/\{\{\s*\w+\s*\}\}/, v);
    }

    var models = [].slice.call(root.querySelectorAll('[data-es-model]'));
    var opts = [].slice.call(root.querySelectorAll('[data-es-opt]'));
    var stage = root.querySelector('[data-es-stage]');
    var thumbsBox = root.querySelector('[data-es-thumbs]');
    var priceEl = root.querySelector('[data-es-price]');
    var wasEl = root.querySelector('[data-es-was]');
    var offEl = root.querySelector('[data-es-off]');
    var barTotal = root.querySelector('[data-es-bar-total]');
    var barWas = root.querySelector('[data-es-bar-was]');
    var barOff = root.querySelector('[data-es-bar-off]');
    var barBtn = root.querySelector('[data-es-checkout]');
    var bar = root.querySelector('.es__bar');
    var railEl = root.querySelector('.es__rail');
    var selected = 0, slide = 0;
    /* ?model=<product handle> opens the page on that model (links from the family pages) */
    try {
      var want = new URLSearchParams(window.location.search).get('model');
      if (want) models.forEach(function (m, i) { if (m.getAttribute('data-handle') === want) selected = i; });
    } catch (e) {}

    function modelData(i) {
      var m = models[i]; if (!m) return null;
      return {
        variant: m.getAttribute('data-variant'),
        price: parseInt(m.getAttribute('data-price'), 10) || 0,
        compare: parseInt(m.getAttribute('data-compare'), 10) || 0,
        images: JSON.parse((m.getAttribute('data-images') || '[]').replace(/\s+/g, ' ').replace(/,\s*]/, ']')),
        logo: m.getAttribute('data-logo') || '',
        addons: m
      };
    }

    function renderThumbs() {
      var d = modelData(selected); if (!d || !thumbsBox) return;
      thumbsBox.innerHTML = '';
      d.images.forEach(function (src, i) {
        var b = document.createElement('button');
        b.className = 'es__thumb' + (i === slide ? ' is-on' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Image ' + (i + 1));
        var item = typeof src === 'string' ? { t: 'i', s: src } : src;
        if (item.t === 'v' && !item.p) { b.classList.add('is-video', 'is-blank'); }
        else { var im = document.createElement('img'); im.src = item.t === 'v' ? item.p : item.s; im.loading = 'lazy'; im.alt = ''; if (item.t !== 'v' && item.fit !== 'contain' && (item.x != null || item.y != null)) im.style.objectPosition = (item.x != null ? item.x : 50) + '% ' + (item.y != null ? item.y : 50) + '%'; b.appendChild(im); if (item.t === 'v') b.classList.add('is-video'); if (item.fit === 'contain') b.classList.add('is-whole'); else if (item.t !== 'v') im.addEventListener('load', function () { var r = im.naturalWidth / (im.naturalHeight || 1); if (r < 1.15 || r > 1.95) b.classList.add('is-whole'); }); }
        b.addEventListener('click', function () { slide = i; renderStage(); renderThumbs(); });
        thumbsBox.appendChild(b);
      });
    }
    function renderStage() {
      var d = modelData(selected); if (!d || !stage) return;
      var src = d.images[slide] || d.images[0]; if (!src) return;
      var item = typeof src === 'string' ? { t: 'i', s: src } : src;
      /* 2.10: the section already drew the first slide while the page was loading (buy-es.liquid, data-es-early): keep it, don't draw it again */
      var early = stage.getAttribute('data-es-early');
      if (early != null) { stage.removeAttribute('data-es-early'); if (early === item.s && stage.firstChild) return; }
      stage.innerHTML = '';
      if (item.t === 'v') {
        var v = document.createElement('video');
        v.muted = true; v.loop = item.loop === true; v.autoplay = true; /* 8.10 Kfir: gallery clips play once and stay on the last frame (it used to loop forever) */ v.playsInline = true; v.setAttribute('playsinline', '');
        if (item.fit === 'contain') v.classList.add('is-contain');
        /* Kfir 25.9: a .mov (HEVC with alpha) goes FIRST so Safari/iPhone picks the transparent file instead of the WebM it decodes without alpha (black box); Chrome cannot play QuickTime and falls through to the WebM. A plain .mp4 keeps the WebM first so Chrome keeps the alpha. */
        var s1 = document.createElement('source'); s1.src = item.s; var isMov = /\.mov(\?|$)/.test(item.s); s1.type = isMov ? 'video/quicktime' : 'video/mp4';
        var s2 = null; if (item.s2) { s2 = document.createElement('source'); s2.src = item.s2; s2.type = 'video/webm'; }
        if (isMov) { v.appendChild(s1); if (s2) v.appendChild(s2); } else { if (s2) v.appendChild(s2); v.appendChild(s1); }
        if (item.p) v.poster = item.p;
        stage.appendChild(v); v.play && v.play().catch(function () {});
      } else {
        var im = document.createElement('img'); im.src = item.s; im.alt = '';
        /* Kfir 27.9 (galcrop): every still fills the same frame edge to edge, cropped around its own focus point
           (x left to right, y top to bottom, in %) so no head, face or product is cut. A product render on white shows whole. */
        if (item.fit === 'contain') im.classList.add('is-contain');
        else if (item.x != null || item.y != null) im.style.objectPosition = (item.x != null ? item.x : 50) + '% ' + (item.y != null ? item.y : 50) + '%';
        stage.appendChild(im);
      }
    }
    function step(dir) {
      var d = modelData(selected); if (!d || !d.images.length) return;
      slide = (slide + dir + d.images.length) % d.images.length;
      renderStage(); renderThumbs();
    }
    var prev = root.querySelector('[data-es-prev]'), next = root.querySelector('[data-es-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function sum() {
      var d = modelData(selected); if (!d) return { total: 0, was: 0 };
      var total = d.price, was = d.compare > d.price ? d.compare : d.price;
      [].slice.call(d.addons.querySelectorAll('[data-es-addon].is-on')).forEach(function (a) {
        var p = parseInt(a.getAttribute('data-price'), 10) || 0;
        total += p; was += p;
      });
      return { total: total, was: was, off: d.compare > d.price ? Math.round((1 - d.price / d.compare) * 100) : 0 };
    }
    function paint() {
      var d = modelData(selected), s = sum();
      opts.forEach(function (o, i) { o.classList.toggle('is-on', i === selected); o.setAttribute('aria-checked', i === selected ? 'true' : 'false'); });
      models.forEach(function (m, i) { m.hidden = i !== selected; });
      [].slice.call(root.querySelectorAll('[data-es-feats]')).forEach(function (f) { f.hidden = parseInt(f.getAttribute('data-es-feats'), 10) !== selected; });
      [].slice.call(root.querySelectorAll('[data-es-terms]')).forEach(function (f) { f.hidden = parseInt(f.getAttribute('data-es-terms'), 10) !== selected; });
      /* the logo is the identity: a model without its own logo keeps the family logo, never a text title */
      var logoEl = root.querySelector('[data-es-logo]'), titleEl = root.querySelector('[data-es-title]');
      if (logoEl && titleEl) {
        var fallback = '';
        for (var k = 0; k < models.length && !fallback; k++) fallback = models[k].getAttribute('data-logo') || '';
        var src = d.logo || fallback;
        if (src) { logoEl.src = src; logoEl.hidden = false; titleEl.classList.add('is-sr'); titleEl.hidden = false; }
        else { logoEl.hidden = true; titleEl.classList.remove('is-sr'); titleEl.hidden = false; }
      }
      if (priceEl) priceEl.textContent = money(d.price);
      /* installments: the model's price in four, same maths as the family card */
      var fin = root.querySelector('[data-es-fin]');
      if (fin) { var tpl = fin.getAttribute('data-tpl') || ''; if (tpl && d.price) { fin.textContent = tpl.replace('{amount}', money(Math.round(d.price / 4))); fin.hidden = false; } else { fin.hidden = true; } }
      if (wasEl) { wasEl.hidden = !(d.compare > d.price); wasEl.textContent = d.compare > d.price ? money(d.compare) : ''; }
      /* 7.10 Kfir: a model shipping now says "Save $150" (dollars feel bigger than a percent on a big price, and it isn't set against the pre-orders' 30%) */
      var saveTxt = (root.hasAttribute('data-save-chip') && !d.addons.hasAttribute('data-pre') && d.compare > d.price) ? 'Save ' + money(d.compare - d.price).replace(/[.,]00(?!\d)/, '') : '';
      if (offEl) { offEl.hidden = !s.off; offEl.textContent = saveTxt || (s.off ? s.off + '% off' : ''); }
      if (barTotal) barTotal.textContent = money(s.total);
      if (barWas) { barWas.hidden = s.was <= s.total; barWas.textContent = s.was > s.total ? money(s.was) : ''; }
      if (barOff) { barOff.hidden = !s.off; barOff.textContent = saveTxt || (s.off ? s.off + '% off' : ''); }
      var avail = d.addons.getAttribute('data-available') !== 'false';
      if (barBtn) {
        barBtn.disabled = !d.variant || !avail;
        /* a pre-order model says so on the button: the buyer pays now and must know it ships later */
        barBtn.textContent = avail ? (d.addons.getAttribute('data-btn') || barBtn.getAttribute('data-label') || 'Checkout') : (barBtn.getAttribute('data-unavailable') || 'Sold out');
        var msg0 = root.querySelector('[data-es-msg]'); if (msg0) { msg0.hidden = true; msg0.textContent = ''; }
        /* 1.11 Dror: a sold-out model gets the "Notify me" link under the button */
        var nf = root.querySelector('[data-es-notify]'), mdl = d.addons.closest('[data-es-model]') || d.addons;
        if (nf) { nf.hidden = avail; nf.setAttribute('data-wjn-handle', mdl.getAttribute('data-wjn-handle') || ''); nf.setAttribute('data-wjn-title', mdl.getAttribute('data-wjn-title') || ''); nf.setAttribute('data-wjn-img', mdl.getAttribute('data-wjn-img') || ''); nf.setAttribute('data-wjn-reason', mdl.getAttribute('data-wjn-reason') || ''); nf.setAttribute('data-wjn-pid', mdl.getAttribute('data-wjn-pid') || ''); nf.setAttribute('data-wjn-variant', (d.variant && d.variant.id) || d.variant || ''); }
      }
      /* the ledger in the bar: total value (struck) -> the advantage (deducted) -> you pay only.
         Only when the model brings more than a price gap; ticked add-ons ride on both sides. */
      var advSave = parseInt(d.addons.getAttribute('data-adv-save'), 10) || 0;
      var advFull = parseInt(d.addons.getAttribute('data-adv-full'), 10) || 0;
      var ledger = root.querySelector('[data-es-ledger]'), payLabel = root.querySelector('[data-es-pay-label]');
      var addonsSum = s.total - d.price;
      /* 28.9 (Kfir, focus group: the value sum read as made-up math): with the ledger switched off, the bar shows the plain price and the struck was-price, no 'You pay only' */
      if (advSave > 0 && advFull > 0 && ledger) {
        if (ledger) {
          ledger.hidden = false;
          var lf = ledger.querySelector('[data-es-full]'), ls = ledger.querySelector('[data-es-save]'), ll = ledger.querySelector('[data-es-save-label]');
          if (lf) lf.textContent = money(advFull + addonsSum);
          if (ls) ls.textContent = '−' + money(advSave);
          if (ll) ll.textContent = d.addons.getAttribute('data-adv-label') || '';
        }
        if (payLabel) payLabel.hidden = false;
        if (barWas) barWas.hidden = true;
        if (barOff) barOff.hidden = true;
      } else {
        if (ledger) ledger.hidden = true;
        if (payLabel) payLabel.hidden = true;
      }
      /* shipping: the model's own time (product metafield) or the visitor's region, never a typed string */
      var ship = d.addons.getAttribute('data-ship') || '', shipLoc = d.addons.getAttribute('data-ship-loc') || '';
      /* a model that cannot be bought gets no shipping line at all (1.11 Dror) */
      var barShip = root.querySelector('[data-es-bar-ship]');
      if (barShip) { var bs = !avail ? '' : (ship || barShip.getAttribute('data-fallback') || ''); barShip.textContent = bs; barShip.hidden = !bs; }
      var shipLine = root.querySelector('[data-es-ship-line]');
      if (shipLine) { var sl = !avail ? '' : (ship + (ship && shipLoc ? ' · ' : '') + shipLoc); shipLine.textContent = sl; shipLine.hidden = !sl; }
      /* 6.10 Kfir: "In stock · Ships in 2 business days from the US" under the price, only for a model in stock in this market and not on pre-order */
      var stockEl = root.querySelector('[data-es-stock]');
      if (stockEl) {
        var stockOn = avail && d.addons.hasAttribute('data-instock') && !d.addons.hasAttribute('data-pre') && !!ship;
        var stockT = stockEl.querySelector('[data-es-stock-t]');
        if (stockOn && stockT) {
          var from = shipLoc.replace(/^ships from\s+/i, 'from ').replace(/,\s*vat included\s*$/i, ''); /* VAT already sits in the trust row up top */
          stockT.textContent = ' · ' + ship + (from && from !== shipLoc ? ' ' + from : (shipLoc ? ' · ' + shipLoc : ''));
        }
        stockEl.hidden = !stockOn;
      }
      /* the feature card image follows the model (its own image, else the section image) */
      var fi = root.querySelector('[data-es-feature]');
      if (fi) { var fsrc = d.addons.getAttribute('data-feature') || fi.getAttribute('data-default') || ''; if (fsrc && fi.getAttribute('src') !== fsrc) fi.setAttribute('src', fsrc); }
      if (typeof placeBar === 'function') placeBar();
    }
    /* 27.9: keep the chosen model in the address (?model=), so a shared link, a reload or the back button
       reopen the same model. replaceState: no extra history entries; ad parameters are kept. */
    function syncUrl() {
      try {
        var h = models[selected] && models[selected].getAttribute('data-handle'); if (!h || models.length < 2) return;
        var u = new URL(window.location.href); if (u.searchParams.get('model') === h) return;
        u.searchParams.set('model', h); history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
    opts.forEach(function (o, i) {
      o.addEventListener('click', function () { selected = i; slide = 0; renderStage(); renderThumbs(); paint(); syncUrl(); });
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-es-addon-locked]')) return; /* a gift tile is information, not a checkbox (Dror, 27.9) */
      var a = e.target.closest('[data-es-addon]'); if (!a) return;
      a.classList.toggle('is-on'); paint();
    });
    var tiers = [].slice.call(root.querySelectorAll('[data-es-tier]'));
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.toggle('is-on', x === t); });
      });
    });
    var tabs = [].slice.call(root.querySelectorAll('.es__tab'));
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); }); });
    });

    /* checkout: the selected model plus every ticked add-on go to the cart, then straight to checkout */
    if (barBtn) barBtn.addEventListener('click', function () {
      var d = modelData(selected); if (!d || !d.variant) return;
      var items = [{ id: parseInt(d.variant, 10), quantity: 1 }];
      [].slice.call(d.addons.querySelectorAll('[data-es-addon].is-on')).forEach(function (a) {
        var v = parseInt(a.getAttribute('data-variant'), 10);
        if (v) items.push({ id: v, quantity: 1 });
      });
      /* the model's gifts ride along, flagged so the cart guard can take them back out if the model leaves the cart */
      /* 8.10 gift test (wj_gt): side b is shown no gift, so no gift rides into its cart */
      if (document.documentElement.getAttribute('data-wjgt') !== 'b') (d.addons.getAttribute('data-gifts') || '').split(',').forEach(function (g) {
        var v = parseInt(g, 10);
        if (v) items.push({ id: v, quantity: 1, properties: { _gift: 'mat-bundle' } });
      });
      barBtn.disabled = true; barBtn.textContent = '...';
      /* cart is the default stop: the cart page carries the shipping protection and the other upsells */
      var go = root.getAttribute('data-go') === 'checkout' ? '/checkout' : '/cart';
      var msg = root.querySelector('[data-es-msg]');
      function fail(text) {
        barBtn.disabled = false; barBtn.textContent = d.addons.getAttribute('data-btn') || barBtn.getAttribute('data-label') || 'Checkout';
        if (msg) { msg.textContent = text || 'Something went wrong, nothing was added. Please try again.'; msg.hidden = false; }
      }
      /* 4.10: tell the stamp script the page is leaving, so it writes nothing to the cart now; the cart page stamps it at once */
      function leave() { window.wjLeaving = true; window.location.href = go; }
      function add(list) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: list }) });
      }
      /* one add-on that can't be sold (sold out, not in this market) must never cost the sale:
         if the full set fails, add the model and its gifts on their own and carry on */
      var core = items.filter(function (it, i) { return i === 0 || (it.properties && it.properties._gift); });
      /* 27.9 (persona Anna): a sold-out pre-order gift ("Silk Eye Mask is already sold out") failed the model too, so MAT Plus/Pro
         could not be pre-ordered at all. Last resort: the model on its own, then each gift on its own; a gift that fails is skipped */
      function modelThenGifts() {
        return add([items[0]]).then(function (r3) {
          if (!r3.ok) return r3.json().then(function (j) { fail(j && (j.description || j.message)); }, function () { fail(); });
          return core.slice(1).reduce(function (p, it) {
            return p.then(function () { return add([it]).catch(function () {}); });
          }, Promise.resolve()).then(function () { leave(); });
        });
      }
      /* 12.10 (Dror's side-b test): the gift discount reads cart attribute wj_gt, and the stamp script writes it only after the
         cart page has loaded, so the cart's first render priced side b's companions as gifts. The side goes on the cart first now. */
      var gtSide = document.documentElement.getAttribute('data-wjgt');
      (gtSide ? fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { wj_gt: gtSide } }) }).catch(function () {}) : Promise.resolve())
        .then(function () { return add(items); })
        .then(function (r) {
          if (r.ok) { leave(); return; }
          if (items.length > core.length) {
            return add(core).then(function (r2) {
              if (r2.ok) { leave(); return; }
              return modelThenGifts();
            });
          }
          return modelThenGifts();
        })
        .catch(function () { fail(); });
    });

    /* the bar lives inside its section: pinned while the section covers the fold,
       rides up with the section's end, never floats over what comes after */
    /* Kfir 27.9 ("it shakes when I scroll"): one update per frame, all reads before any write, and a style is
       only written when its value really changes. Writing the root var and reading the bar's rect on every
       scroll event forced a layout per event and made the fixed bar and the chat bubble jitter. */
    var lastVals = {}, barTick = false;
    function setIf(el, key, prop, val) {
      if (lastVals[key] === val) return;
      lastVals[key] = val;
      if (prop.charAt(0) === '-') { if (val == null) el.style.removeProperty(prop); else el.style.setProperty(prop, val); }
      else el.style[prop] = val;
    }
    function doPlaceBar() {
      barTick = false;
      if (!bar || !railEl) return;
      var docEl = document.documentElement, vw = window.innerWidth, vh = window.innerHeight;
      /* reads */
      var r = railEl.getBoundingClientRect(), box = root.getBoundingClientRect(), bh = bar.offsetHeight;
      var off = parseInt(docEl.style.getPropertyValue('--es-bar-offset'), 10) || 0;
      /* writes. Phones: edge to edge (Kfir 26.9); desktop: the width of the buying column */
      if (vw <= 899) { setIf(bar, 'l', 'left', '0px'); setIf(bar, 'w', 'width', '100%'); }
      else { setIf(bar, 'l', 'left', Math.round(r.left) + 'px'); setIf(bar, 'w', 'width', Math.round(r.width) + 'px'); }
      /* --es-bar-offset is the open cookie banner's height (bannerOffset below); the bar sits above both */
      var rise = Math.max(0, Math.round(vh - box.bottom));
      setIf(bar, 'b', 'bottom', rise ? 'calc(var(--es-bar-offset, 0px) + ' + rise + 'px)' : '');
      var gone = box.bottom < 140 || box.top > vh - 80;
      if (bar.classList.contains('is-gone') !== gone) bar.classList.toggle('is-gone', gone);
      /* 27.9 (persona Tom): on a phone, bar + open cookie banner left no room for the product on the first screen.
         While the banner is open the bar waits (it comes back the moment the visitor answers); desktop keeps it above the banner */
      var bannerUp = vw <= 899 && off > 0;
      if (bar.classList.contains('is-banner') !== bannerUp) bar.classList.toggle('is-banner', bannerUp);
      /* the chat bubble sits just above the bar, however tall the bar is (the MAT Plus/Pro bar grows with its savings rows),
         or just above the cookie banner while the bar waits */
      var chatB = bannerUp ? off + 12 : (gone ? (off ? off + 12 : null) : off + rise + bh + 12);
      setIf(docEl, 'c', '--es-chat-bottom', chatB == null ? null : chatB + 'px');
    }
    /* 12.10 (Dror: "the sticky button jumps when I scroll"): doPlaceBar moves a fixed bar on every scroll frame and runs
       one frame behind the page. Sticky mode lets the browser pin the bar instead (position: sticky inside its section,
       same resting place at the section's end); the script only measures on resize and when the bar changes height.
       Sticky is the default on every buy page since 12.10 (Dror); ?esbar=off brings back the old scroll-driven bar for the visit. */
    var stickyBar = true, barInView = true;
    try {
      var esq = new URLSearchParams(window.location.search).get('esbar');
      if (esq === 'off') sessionStorage.setItem('esbar', 'off');
      else if (esq === 'sticky') sessionStorage.removeItem('esbar');
      stickyBar = sessionStorage.getItem('esbar') !== 'off';
    } catch (e) {}
    function doSizeBar() {
      barTick = false;
      if (!bar || !railEl) return;
      var docEl = document.documentElement, vw = window.innerWidth;
      /* reads */
      var r = railEl.getBoundingClientRect(), box = root.getBoundingClientRect(), bh = bar.offsetHeight;
      var off = parseInt(docEl.style.getPropertyValue('--es-bar-offset'), 10) || 0;
      /* writes: the bar overlaps the section's last bh px (as before); phones edge to edge, desktop the buying column */
      setIf(root, 'sh', '--es-bar-h', bh + 'px');
      if (vw <= 899) { setIf(root, 'sx', '--es-bar-x', '0px'); setIf(root, 'sw', '--es-bar-w', '100%'); }
      else { setIf(root, 'sx', '--es-bar-x', Math.round(r.left - box.left) + 'px'); setIf(root, 'sw', '--es-bar-w', Math.round(r.width) + 'px'); }
      var bannerUp = vw <= 899 && off > 0;
      if (bar.classList.contains('is-banner') !== bannerUp) bar.classList.toggle('is-banner', bannerUp);
      var chatB = bannerUp ? off + 12 : (barInView ? off + bh + 12 : (off ? off + 12 : null));
      setIf(docEl, 'c', '--es-chat-bottom', chatB == null ? null : chatB + 'px');
    }
    function placeBar() { if (!barTick) { barTick = true; requestAnimationFrame(stickyBar ? doSizeBar : doPlaceBar); } }
    if (stickyBar && bar && railEl) {
      root.classList.add('es--sticky-bar');
      doSizeBar();
      if (window.ResizeObserver) new ResizeObserver(placeBar).observe(bar);
      if (window.IntersectionObserver) new IntersectionObserver(function (en) { barInView = en[0].isIntersecting; placeBar(); }).observe(root);
    } else {
      doPlaceBar();
      window.addEventListener('scroll', placeBar, { passive: true });
    }
    window.addEventListener('resize', placeBar, { passive: true });

    /* the cookie banner (Pandectes: a <dialog class="notice"> docked at the bottom edge, inside an open shadow
       root) covered the bar on the first visit. Measure it while it is open, publish the height as
       --es-bar-offset on the root so the bar rides above it, and measure again on resize and whenever the
       banner appears, changes or goes away (MutationObserver on body and on the banner's shadow root). */
    var bannerRoot = null, bannerObs = null, offsetTimers = [];
    function bannerOffset() {
      var off = 0;
      try {
        var host = document.querySelector('pandectes-cmp');
        var sr = host && host.shadowRoot;
        if (sr) {
          [].slice.call(sr.querySelectorAll('dialog.notice, dialog[aria-label]')).forEach(function (el) {
            var cs = window.getComputedStyle(el);
            if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') return;
            var r = el.getBoundingClientRect();
            /* only a banner docked at the bottom edge counts: never a centred preferences modal or a full-screen wrapper */
            if (r.height < 20 || r.top <= 0 || r.bottom < window.innerHeight - 4) return;
            off = Math.max(off, Math.round(window.innerHeight - r.top));
          });
        }
      } catch (e) {}
      return off;
    }
    function applyOffset() {
      var want = bannerOffset(), rs = document.documentElement.style;
      var cur = parseInt(rs.getPropertyValue('--es-bar-offset'), 10) || 0;
      if (cur === want) return;
      if (want) rs.setProperty('--es-bar-offset', want + 'px'); else rs.removeProperty('--es-bar-offset');
      placeBar();
    }
    function scheduleOffset() {
      applyOffset();
      offsetTimers.forEach(clearTimeout);
      /* the banner animates in and out: measure again once it has settled */
      offsetTimers = [setTimeout(applyOffset, 400), setTimeout(applyOffset, 1200)];
    }
    function watchBanner() {
      var host = document.querySelector('pandectes-cmp'), sr = host && host.shadowRoot;
      if (sr && sr !== bannerRoot) {
        if (bannerObs) bannerObs.disconnect();
        bannerRoot = sr;
        bannerObs = new MutationObserver(scheduleOffset);
        bannerObs.observe(sr, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class', 'style', 'hidden'] });
      } else if (!host && bannerRoot) { if (bannerObs) bannerObs.disconnect(); bannerObs = null; bannerRoot = null; }
      scheduleOffset();
    }
    if (window.MutationObserver) {
      new MutationObserver(watchBanner).observe(document.body, { childList: true });
      /* the banner script is deferred and mounts on its own clock: keep looking for a while after load */
      var bannerPolls = 0, bannerPoll = setInterval(function () { watchBanner(); if (++bannerPolls >= 30) clearInterval(bannerPoll); }, 500);
      window.addEventListener('resize', scheduleOffset, { passive: true });
      watchBanner();
    }

    renderStage(); renderThumbs(); paint();
    /* the section hid its model parts until the ?model= one is painted (buy-es.liquid, .es--pre) */
    root.classList.remove('es--pre');
  }
  [].slice.call(document.querySelectorAll('[data-buy-es]')).forEach(init);
})();
